import { Routes } from '@angular/router';

export const PUBLIC_ROUTES: Routes = [
    { path: 'users', loadChildren: './user/user.module#UserModule' },
    { path: '', redirectTo: 'users/login', pathMatch: 'full' },
];
